import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Card, Col, Container, Row } from 'react-bootstrap';
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import { findIndex, set } from 'lodash';
import PeriodSelection from '../../../components/selections/periodSelection/periodSelection';
import DataTableComponent from '../../../components/dataTables/dataTable';
import { EffectServiceApi } from "../../../services/marketQuery/api";
import { Configuration } from "../../../services/marketQuery/configuration"
import { useDispatch, useSelector } from "react-redux";
import { IndexServiceApi, PageName } from "../../../services/actionHub/api";
import { Configuration as IndexServiceApiConfiguration } from "../../../services/actionHub/configuration";
import { act } from 'react-test-renderer';
import lodash from 'lodash';
import NumberFormatter from '../../../formatters/NumberFormatter'
import Spinner from '../../../components/spinner';
import { is } from 'date-fns/locale';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
const StockIndexEffect = () => {
    const { t } = useTranslation();
    const numberFormatter = new NumberFormatter();
    const marketApi = new EffectServiceApi(new Configuration({ basePath: process.env.REACT_APP_MARKET_QUERY_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_MARKET_QUERY_API_BASE_PATH));
    const actionHubIndexApi = new IndexServiceApi(new IndexServiceApiConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const user = useSelector((state) => state.auth?.user);
    const accountId = useSelector((state) => state.auth?.accountId);
    const toast = useRef(null);
    const [indexList, setIndexList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState();
    const [activePeriod, setActivePeriod] = useState(t('period.weekly'));
    const [columnsData, setColumnsData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [marketIndexEffectData, setMarketIndexEffectData] = useState([]);
    const [actionHubIndexData, setActionHubIndexData] = useState([]);
    const [stockIndexEffectTableData, setStockIndexEffectTableData] = useState([]);
    const token = localStorage.getItem('token');
    // const periods = ['Günlük', 'Haftalık', 'Aylık', 'Yılbaşına Göre', 'Yıllık'];
    const periods = [t('period.daily'), t('period.weekly'), t('period.monthly'), t('period.ytd'), t('period.yearly')];
    const [isLoading, setIsLoading] = useState(true);
    const [sortField, setSortField] = useState('rocWeeklyChange');
    const [sortOrder, setSortOrder] = useState(-1); // 1 for ascending, -1 for descending

    let field = '';
    const columns = [
        // { id: 1, field: 'fav', displayName: 'Favoriler', header: '', isVisible: true, align: 'left' },
        // { id: 2, field: 'code', displayName: 'Hisse Kodu', header: 'Hisse Kodu', isVisible: true, align: 'left', width: '15%', clikable: true },
        // { id: 1, field: 'searchableHeader', displayName: 'Sembol', header: 'Sembol Adı', filterField: "name", isFrozen: true, format: "code-s-t", isVisible: true, align: 'left', width: '1%', paddingRight: '0px', sortable: false },
        { id: 2, field: 'searchableHeader', displayName: 'Sembol', header: '', filterField: "code", isFrozen: true, format: "code-s-f", isVisible: true, align: 'left', width: '2%', paddingRight: '0px', sortable: false },
        { id: 3, field: 'name', displayName: 'Hisse Adı', header: t('tableHeader.shareName'), isVisible: true, align: 'left', width: '15%', elipsisName: true },
        { id: 4, field: 'technicalAnalysis', displayName: 'Teknik Analiz', header: '', isVisible: true, align: 'left', width: '1%' },
        { id: 5, field: 'betaCoefficient', displayName: 'Beta Katsayısı', header: t('tableHeader.betaCoefficient'), isVisible: true, align: 'right', width: '13%', sortable: true },
        { id: 6, field: 'indexAmount', displayName: 'Endeks Etkisi Miktar', header: t('tableHeader.indexEffectQuantity'), isVisible: true, align: 'right', width: '17%', sortable: true },
        { id: 7, field: 'indexRatio', displayName: 'Endeks Etkisi Oran', header: t('tableHeader.indexEffectRate') +' (%)', template: '', isVisible: true, align: 'right', width: '15%', sortable: true },
        { id: 8, field: 'lastPrice', displayName: 'Son', header: t('tableHeader.last'), isVisible: true, align: 'right', sortabled: true, width: '8%', sortable: true },
        { id: 9, field: 'rocDailyChange', displayName: 'rocDaily', header: t('tableHeader.change'), template: '', isVisible: false, align: 'center', width: '10%', sortable: true },
        { id: 10, field: 'rocWeeklyChange', displayName: 'rocWeekly', header: t('tableHeader.change'), template: '', isVisible: true, align: 'center', width: '10%', sortable: true },
        { id: 11, field: 'rocMonthlyChange', displayName: 'rocMonthly', header: t('tableHeader.change'), template: '', isVisible: false, align: 'center', width: '10%', sortable: true },
        { id: 12, field: 'rocYtdChange', displayName: 'rocYtd', header: t('tableHeader.change'), template: '', isVisible: false, align: 'center', width: '10%', sortable: true },
        { id: 13, field: 'rocAnnualChange', displayName: 'rocAnnual', header: t('tableHeader.change'), template: '', isVisible: false, align: 'center', width: '9%', sortable: true },
        { id: 14, field: 'dividendYield', displayName: 'Temettü Getirisi', header: t('tableHeader.dividendYield')+' (%)', template: '', isVisible: true, align: 'right', width: '11%', infoLabel: 'Yıllık' },
    ];

    useEffect(() => {
        console.log('Stock Index Effect');
        // setSelectedIndex(indexes[2]); 
        setColumnsData(columns);
        getActionHubStockIndexData();
    }, []);

    useEffect(() => {
        console.log('selectedIndex', selectedIndex);
        if (selectedIndex) {
            getMarketStockIndexData();
        }
    }, [selectedIndex]);


    //#region  Period Selection
    const clickPeriod = (period) => {
        console.log(period);
        setActivePeriod(period);

        setColumnsData((prevData) => {
            const newData = [...prevData];
            prevData.forEach(obj => {
                if (period == t('period.daily')) {
                    if (obj.field == 'rocDailyChange') {
                        obj.isVisible = true;
                    }
                    else if (obj.field.includes('roc')) {
                        obj.isVisible = false;
                    }

                    let sorted = sortData('rocDaily');
                    setStockIndexEffectTableData(sorted);

                }
                else if (period == t('period.weekly')) {
                    if (obj.field == 'rocWeeklyChange') {
                        obj.isVisible = true;
                    }
                    else if (obj.field.includes('roc')) {
                        obj.isVisible = false;
                    }

                    let sorted = sortData('rocWeekly');

                    setStockIndexEffectTableData(sorted);
                }
                else if (period == t('period.monthly')) {
                    if (obj.field == 'rocMonthlyChange') {
                        obj.isVisible = true;
                    }
                    else if (obj.field.includes('roc')) {
                        obj.isVisible = false;
                    }

                    let sorted = sortData('rocMonthly');

                    setStockIndexEffectTableData(sorted);
                }
                else if (period == t('period.ytd')) {
                    if (obj.field == 'rocYtdChange') {
                        obj.isVisible = true;
                    }
                    else if (obj.field.includes('roc')) {
                        obj.isVisible = false;
                    }

                    let sorted = sortData('rocYtd');

                    setStockIndexEffectTableData(sorted);
                }
                else if (period == t('period.yearly')) {
                    if (obj.field == 'rocAnnualChange') {
                        obj.isVisible = true;
                    }
                    else if (obj.field.includes('roc')) {
                        obj.isVisible = false;
                    }
                    let sorted = sortData('rocAnnual');
                    setStockIndexEffectTableData(sorted);
                }
            });
            return newData;
        });

    }

    const sortData = (field) => {
        return stockIndexEffectTableData.sort((a, b) => {
            const numA = parseFloat(a[field]);
            const numB = parseFloat(b[field]);

            if (isNaN(numA) && isNaN(numB)) {
                return 0;
            }

            if (isNaN(numA)) {
                return 1;
            }

            if (isNaN(numB)) {
                return -1;
            }

            // Büyükten küçüğe sıralama için sıralama mantığını tersine çeviriyoruz
            return numB - numA;
        });
    };

    //#endregion period selection

    //#region Dropdown Picker

    const onIndexListChange = (e) => {
        console.log('onIndexChange', e);

        // setSelectedIndex(e.value);

        let index = findIndex(indexList, { entityId: e.entityId });
        if (index !== -1) {
            setSelectedIndex(indexList[index]);
        }
        else {
            setSelectedIndex(indexList[0]);
        }
    }

    //#endregion Dropdown Picker

    //#region API CALLS

    //#region MARKET STOCK INDEX EFFECT

    const getMarketStockIndexData = () => {

        setIsLoading(true);
        // let identityToken = user["TokenId"];
        let indexEntityId = selectedIndex['entityId'];

        marketApi.marketEffectGet(token, indexEntityId).then((res) => {
            setMarketIndexEffectData(res.data.effectValues);
            // setStockIndexEffectTableData(res.data);
            let array = res.data.effectValues;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                // element.date = element.lastDay.day + '/' + element.lastDay.month + '/' + element.lastDay.year;
                // element.lastValue = element.lastValue;
                // element.rocDailyRaw = element.rocDaily;
                // element.rocWeeklyRaw = element.rocWeekly;
                // element.rocMonthlyRaw = element.rocMonthly;
                // element.rocYtdRaw = element.rocYtd;
                // element.rocAnnualyRaw = element.rocAnnualy;
                element.code = element.Code;
                element.entityId = element.EntityId;
                // element.name = element.name;
                if (element.BetaCoefficient === 'Missing Function') {
                    element.BetaCoefficient = '-';
                }
                else {
                    element.BetaCoefficient = numberFormatter.Double(element.BetaCoefficient, 2);
                }

                if (element.IndexAmount === 'Missing Function') {
                    element.IndexAmount = '-';
                }
                else {
                    element.IndexAmount = numberFormatter.Double(element.IndexAmount, 2);
                }

                if (element.IndexRatio === 'Missing Function') {
                    element.IndexRatio = '-';
                }
                else {
                    element.IndexRatio = numberFormatter.Double(element.IndexRatio, 2);
                }

                if (element.IndexEffect === 'Missing Function') {
                    element.IndexEffect = '-';
                }
                else {
                    element.IndexEffect = numberFormatter.Double(element.IndexEffect, 2);
                }
                if (element.weightIndex === 'Missing Function') {
                    element.weightIndex = '-';
                }
                else {
                    element.weightIndex = numberFormatter.Double(element.weightIndex, 2);
                }
                element.lastValue = numberFormatter.Double(element.lastValue, 2);
                element.rocDailyChange = numberFormatter.Double(element.rocDaily, 2);
                element.rocWeeklyChange = numberFormatter.Double(element.rocWeekly, 2);
                element.rocMonthlyChange = numberFormatter.Double(element.rocMonthly, 2);
                element.rocYtdChange = numberFormatter.Double(element.rocYtd, 2);
                element.rocAnnualChange = numberFormatter.Double(element.rocAnnual, 2);
                element.DividendYield = numberFormatter.Double(element.DividendYield, 2);

            }
            let sorted = array.sort((a, b) => { return b.rocWeekly - a.rocWeekly });
            setStockIndexEffectTableData(sorted);

            console.log(res);
            setTimeout(() => {

                setIsLoading(false);
            }, 1500);
        }).catch((err) => {
            console.log(err);
        });
    }

    //#endregion MARKET STOCK INDEX EFFECT

    //#region ACTION HUB STOCK INDEX EFFECT

    const getActionHubStockIndexData = () => {

        actionHubIndexApi.actionhubCustomindexesGet(token, PageName.StockIndexEffect).then((res) => {
            setActionHubIndexData(res.data.indexes);

            const indexListData = lodash.map(res.data.indexes, (res) => ({
                name: res['name'].trTr,
                nameEnUs: res['name'].enUs,
                code: res.code,
                entityId: res.entityId,
            }))
            setIndexList(indexListData);
            if (indexListData.length > 0) {
                const index = lodash.findIndex(indexListData, { entityId: 'sec.101.411' }); // BIST 100
                if (index !== -1) {
                    setSelectedIndex(indexListData[index]);
                }
                else {
                    setSelectedIndex(indexListData[0]);
                }
            }

        });
        // console.log(indexListData);
    }
    //#endregion ACTION HUB STOCK INDEX EFFECT

    //#endregion API CALLS
    const handleSortChange = (field, order) => {
        setSortField(field);
        setSortOrder(order);
    };
    return (
        <div className='stock-index-summary-screen'>
            <Toast ref={toast} position="bottom-right" />

            {/* LiveTickerBar */}
            <LiveTickerBar />

            {/* <Container>
                <Row>
                    <Col>
                    </Col>
                </Row>
            </Container> */}
            {/* LiveTickerBar */}

            {/* Options Row */}

            <Container className='m-t-20'>
                <Row>
                    <Col md='3' className='p-0'>
                        <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true} />
                    </Col>
                    <Col md='9' className='p-0 text-align-right'>
                        <PeriodSelection periods={periods} activePeriod={activePeriod} clickPeriod={clickPeriod} />
                    </Col>
                </Row>
            </Container>

            {/* 
            <div className='options-div'>
                <div className='item '>
                    <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true} />
                </div>
                <div className='item'>
                    <PeriodSelection periods={periods} activePeriod={activePeriod} clickPeriod={clickPeriod} />
                </div>

            </div> */}
            {/* Options Row */}

            {/* Data Table */}
            <Card className='grid-card m-t-20 stock-index-effect-table' style={{ width: '100%' }}>
                {isLoading && <Spinner height="600px" />}
                {!isLoading &&
                    <DataTableComponent
                        columnsProp={columnsData}
                        dataProp={stockIndexEffectTableData}
                        columnsSelect={false}
                        search={false}
                        absoluteSearch={false}
                        scrollHeight={'100%'}

                    // sortField={sortField}
                    // sortOrder={sortOrder}
                    />
                }

            </Card>
            {/* Data Table */}
        </div>
    )
}

export default StockIndexEffect;
